<template>
    <div id="notes-page">
        <b
            >Disclaimer: I wrote these notes for my personal use and they may
            have mistakes.</b
        >
        <Hairline />
        <Card title="The Sullivan Conjecture">
            <template #description>
                <a
                    class="link"
                    rel="noopener noreferrer"
                    target="_blank"
                    href="/NotePDFs/The%20Sullivan%20Conjecture.pdf"
                    >Notes</a
                >
                for a talk I gave at the University of Toronto Kan seminar.
            </template>
        </Card>
        <Hairline />
        <Card title="The Dwyer—Weiss—Williams Theorem">
            <template #description>
                <a
                    class="link"
                    rel="noopener noreferrer"
                    target="_blank"
                    href="/NotePDFs/The%20Dwyer-Weiss-Williams%20Theorem.pdf"
                    >Notes</a
                >
                for a talk I gave at Alexander Kuper's Simple Homotopy Week.
            </template>
        </Card>
        <Hairline />
        <Card title="Assembly in the Land of Waldhausen">
            <template #description>
                <a
                    class="link"
                    rel="noopener noreferrer"
                    target="_blank"
                    href="/NotePDFs/Assembly%20in%20the%20Land%20of%20Waldhausen.pdf"
                    >Notes</a
                >
                for a talk I gave at Alexander Kuper's Simple Homotopy Week.
            </template>
        </Card>
        <Hairline />

        <Card title="Local Systems in Simple Homotopy Theory">
            <template #description>
                <a
                    class="link"
                    rel="noopener noreferrer"
                    target="_blank"
                    href="/NotePDFs/Local%20Systems%20in%20Simple%20Homotopy%20Theory.pdf"
                    >Notes</a
                >
                for a talk I gave in the
                <a
                    class="link"
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://locallytrivialseminar.github.io"
                    >Locally Trivial Seminar</a
                >.</template
            >
        </Card>
        <Hairline />
        <Card title="K-Theory of Finite Fields">
            <template #description>
                <a
                    class="link"
                    rel="noopener noreferrer"
                    target="_blank"
                    href="/NotePDFs/K-Theory%20of%20Finite%20Fields.pdf"
                    >Notes</a
                >
                for a talk I gave in
                <a
                    class="link"
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.utsc.utoronto.ca/people/kupers/"
                    >Alexander Kupers</a
                >' learning seminar on
                <a
                    class="link"
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.utsc.utoronto.ca/people/kupers/seminars/learning-seminar-on-the-stable-cohomology-of-glnz/"
                    >Stable Cohomology of the General Linear Group</a
                >.</template
            >
        </Card>
        <Hairline />
        <Card title="An Introduction to Mapping Class Groups">
            <template #description>
                <a
                    class="link"
                    rel="noopener noreferrer"
                    target="_blank"
                    href="/NotePDFs/Mapping%20Class%20Groups.pdf"
                    >Notes</a
                >
                for a talk I gave in
                <a
                    class="link"
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.math.toronto.edu/rafi/"
                    >Kasra Rafi</a
                >'s seminar on
                <a
                    class="link"
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.math.toronto.edu/rafi/MAT1350.html"
                    >Combinatorial Teichmüller Theory</a
                >.</template
            >
        </Card>
        <!-- <Hairline />
        <Card
            title="The Third Homotopy Group of The Sphere and The Hopf Fibration"
        >
            <template #description>
                <a
                    class="link"
                    rel="noopener noreferrer"
                    target="_blank"
                    href="/NotePDFs/Hopf%20Fibration.pdf"
                    >Notes</a
                >
                for a talk I gave at the 25th Canadian Undergraduate Mathematics
                conference.</template
            >
        </Card> -->
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Card from "@/components/Card.vue";
import Hairline from "@/components/Hairline.vue";

export default defineComponent({
    components: { Card, Hairline },
});
</script>

<style lang="scss">
@use "@/assets/global";

#notes-page {
    margin-left: global.$side-margin-width;
    margin-right: global.$side-margin-width;
    margin-bottom: global.$top-margin-width;
}
</style>
